import { render, staticRenderFns } from "./ReceivePrintDetails_Receive.vue?vue&type=template&id=c8f1a490&"
import script from "./ReceivePrintDetails_Receive.vue?vue&type=script&lang=js&"
export * from "./ReceivePrintDetails_Receive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports